import React from "react";
import '../index.css';
import TopBar from "../components/AssessmentTopBar";
import SideBar from "../components/AssessmentSideBar";
import Exams from "../exams/Grade1to3";

function BalancesLayout(){
    return (
    <div className="d-flex flex-column" id="kt_app_root">
      {/* Top Navbar */}
      <TopBar />

      {/* Dashboard content container */}
      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <SideBar />

        {/* Main Content Area */}
        <div className="flex-grow-1 p-4">
            <Exams />
        </div>
      </div>
    </div>

    );
}

export default BalancesLayout;